export default "__VITE_ASSET__gY_FghF7__"